var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.562 21.604H9.636a1.315 1.315 0 01-1.298-1.298v-7.898h-2.42A1.315 1.315 0 014.62 11.11V8.844c0-.704.594-1.298 1.298-1.298h2.398V5.5c0-3.036 2.002-5.082 4.994-5.082h2.222c.704 0 1.298.594 1.298 1.298V4.4c0 .704-.594 1.298-1.298 1.298h-1.65v1.848h2.2c.396 0 .77.176 1.012.484s.352.704.264 1.078l-.462 2.244c-.11.594-.66 1.034-1.276 1.034h-1.76v7.92c0 .682-.594 1.298-1.298 1.298zM5.918 8.756a.095.095 0 00-.088.088v2.288c0 .044.044.088.088.088h3.63v9.086c0 .044.044.088.088.088h2.926a.095.095 0 00.088-.088v-9.13h2.97c.044 0 .088-.022.088-.044l.462-2.266c0-.044 0-.066-.022-.088-.022-.022-.044-.022-.088-.022h-3.388v-2.97c0-.792.22-1.298 1.32-1.298h1.54a.095.095 0 00.088-.088V1.694a.095.095 0 00-.088-.088H13.31c-2.288 0-3.784 1.518-3.784 3.872v3.256H5.918v.022z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d8878d24.svg";
export { ForwardRef as ReactComponent };